import * as Sentry from '@sentry/react';
import { useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import toast from 'react-hot-toast';
import { markBusinessAsChurned } from 'api/admin/businesses/businesses';
import { ApiError } from 'types/api';

interface MarkBusinessAsChurnedPayload {
  successCallback?: () => void;
}

interface BusinessIdPayload {
  businessId: number;
}

interface SuccessResponse {
  success: boolean;
}

export const useMarkBusinessAsChurned = ({ successCallback }: MarkBusinessAsChurnedPayload) => {
  return useMutation<unknown, ApiError, BusinessIdPayload>({
    mutationFn: async ({ businessId }) => {
      if (!businessId) {
        return null;
      }

      const { data } = (await markBusinessAsChurned(businessId)) as AxiosResponse<SuccessResponse>;

      return data;
    },
    onSuccess: () => {
      successCallback?.();
      toast('Business successfully marked as churned', {
        duration: 4000,
      });
    },
    onError: (error) => {
      Sentry.captureException(error);
      toast.error(
        error?.response?.data?.error ?? 'An error occurred while marking the business as churned',
        {
          duration: 4000,
        },
      );
    },
  });
};
